import {Button, LinkButton, Tooltip, type ButtonProps} from '@primer/react'

import type {ConflictMergeConditionPayload} from '../../../page-data/payloads/merge-box'
import {ResolveConflictsAgentMenu} from './ResolveConflictsAgentMenu'
import type {ConflictsSectionStatuses} from '../../../types'

/**
 *
 * Renders the "Resolve conflicts" link button and handles the inactive state if the viewer cannot resolve conflicts in the web.
 */
export function ResolveConflictsButton({
  conflictsWebEditorPath,
  conflictsState,
  onError,
  showAgentOption,
  webEditorConflictResolution,
  size,
}: {
  conflictsWebEditorPath: string
  conflictsState: ConflictsSectionStatuses
  onError: (message: string) => void
  showAgentOption: boolean
  webEditorConflictResolution: ConflictMergeConditionPayload['webEditorConflictResolution']
  size?: ButtonProps['size']
}) {
  if (conflictsState !== 'HAS_CONFLICTS') return null
  if (!webEditorConflictResolution) return null

  if (
    !webEditorConflictResolution.viewerCanResolve &&
    (!showAgentOption || webEditorConflictResolution.viewerCannotResolve?.reason !== 'TOO_COMPLEX')
  ) {
    return (
      <Tooltip direction="nw" text={webEditorConflictResolution.viewerCannotResolve?.message || ''}>
        <Button inactive size={size}>
          Resolve conflicts
        </Button>
      </Tooltip>
    )
  }

  if (showAgentOption) {
    return (
      <ResolveConflictsAgentMenu
        conflictsWebEditorPath={conflictsWebEditorPath}
        onError={onError}
        webEditorConflictResolution={webEditorConflictResolution}
        size={size}
      />
    )
  }

  return (
    <LinkButton href={conflictsWebEditorPath} size={size}>
      Resolve conflicts
    </LinkButton>
  )
}
